import React from "react";
import {observer} from "mobx-react-lite";
import "./ListHeader.css"

const ListHeader = observer(() => {

    return (
        <div className="list_header">
            <div className="smart_label">
                <img className="smart_label_logo" alt="smart label"
                     src={"https://cdn.scanbuy.com/sl/logo_0f7566ccf5.png"}/>
                <div className="product_search">Product Search</div>
            </div>
            <div className="paragraph_blue">
                FIND DETAILED INFORMATION ON PRODUCTS IN THE LIST BELOW
            </div>
            <div className="paragraph_grey">
                Or search other brands and products using the search tool
            </div>
        </div>
    )
})

export default ListHeader;
